"use client";

import { ArrowDownIcon } from "lucide-react";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { TooltipIconButton } from "@/components/assistant-ui/tooltip-icon-button";
import { useVirtualizedMessages } from "@/components/assistant-ui/thread/VirtualizedMessages";

export const ThreadScrollToBottom: FC = () => {
  const { t } = useTranslation();
  const { isAtBottom, scrollToBottom } = useVirtualizedMessages();

  if (isAtBottom) return null;

  return (
    <TooltipIconButton
      tooltip={t("thread.scrollToBottom")}
      variant="outline"
      className="aui-thread-scroll-to-bottom absolute -top-12 z-10 self-center rounded-full p-4 dark:bg-background dark:hover:bg-accent"
      onClick={scrollToBottom}
    >
      <ArrowDownIcon />
    </TooltipIconButton>
  );
};
